import { Tr } from "@chakra-ui/react";
import { FC } from "react";

const TableRow: FC = ({ children }) => <Tr>{children}</Tr>;

export default TableRow;
